import { MenuResponse } from "api"
import { NestedNavigationLinksType } from "common/SiteLinks"

/**
 * Maps the CMS menu payload (`GET /api/menu`) to the header's existing
 * `NestedNavigationLinksType[]` shape so HeaderLinkList/HeaderSubCollapse can
 * render it unchanged.
 *
 * - `subLinks` present  → dropdown: `links` holds the sub-links (the top label
 *   does not navigate; its `url` is the `"parent"` sentinel).
 * - `subLinks` null/empty → plain link: a single entry pointing at `item.url`.
 *
 * Returns `undefined` when there's no menu data so the header falls back to its
 * hardcoded nav.
 */
export const mapMenuToNavLinks = (
  menu: MenuResponse | null | undefined
): NestedNavigationLinksType[] | undefined => {
  const items = menu?.items
  if (!items?.length) return undefined

  return items.map((item) => {
    const subLinks = item.subLinks
    if (subLinks && subLinks.length > 0) {
      return {
        title: item.label,
        links: subLinks.map((sub) => ({ title: sub.label, link: sub.url })),
      }
    }
    return { title: item.label, links: [{ title: item.label, link: item.url }] }
  })
}
